<template>
  <div id="app" >
    <!--    <div id="fps" class="fixed z-50"></div>-->
    <MessageSent v-if="messageSent" @onComplete="messageSent = false"/>
    <div class="grid grid-rows-layout grid-cols-columns"
         ref="scrollSections"
         :key="someKey">
      <Navbar @scrollTo="scrollTo"/>
      <PageHeader @scrollTo="scrollTo"/>
      <Stepper/>
      <CalculatorSteps ref="calculator-container" @messageSent="messageSent = true"/>
      <Features/>
      <Contact ref="contact-container" @messageSent="messageSent = true"/>
      <PageFooter/>
    </div>
  </div>
</template>

<script>
import {gsap} from "gsap";
import Navbar from "./components/navbar/Navbar";
import PageHeader from "@/components/header/PageHeader";
import Stepper from "@/components/stepper/Stepper";
import CalculatorSteps from "./components/calculator-steps/CalculatorSteps";
import Features from "@/components/features/Features";
import Contact from "@/components/contact/Contact";
import PageFooter from "@/components/pagefooter/PageFooter";
import LocomotiveScroll from "locomotive-scroll";

import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import MessageSent from "@/components/message-sent/MessageSent";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin)


export default {
  name: "App",
  data: () => ({
    x: null,
    someKey: 0,
    scroll: undefined,
    messageSent: false
  }),
  components: {
    Navbar,
    PageHeader,
    Stepper,
    CalculatorSteps,
    Features,
    Contact,
    PageFooter,
    MessageSent
  },
  methods: {
    scrollTo(containerRef) {
      const target = this.$refs[containerRef]
      this.scroll.scrollTo(target.$el)
    }
  },
  mounted() {
    // var fps = document.getElementById("fps"),
    //     startTime = Date.now(),
    //     frame = 0;
    //
    // function tick() {
    //   var time = Date.now();
    //   frame++;
    //   if (time - startTime > 1000) {
    //     fps.innerHTML = (frame / ((time - startTime) / 1000)).toFixed(1);
    //     startTime = time;
    //     frame = 0;
    //   }
    //   window.requestAnimationFrame(tick);
    // }
    // tick();

    const _self = this
    const locoScroll = new LocomotiveScroll({
      el: _self.$refs['scrollSections'],
      smooth: true
    });

    this.x = locoScroll;

    locoScroll.on("scroll", ScrollTrigger.update);

    ScrollTrigger.scrollerProxy(_self.$refs['scrollSections'], {
      scrollTop(value) {
        return arguments.length
            ? locoScroll.scrollTo(value, 0, 0)
            : locoScroll.scroll.instance.scroll.y;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight
        };
      },
      pinType: _self.$refs['scrollSections'].style.transform
          ? "transform"
          : "fixed"
    });
    ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
    ScrollTrigger.refresh();
    this.scroll = locoScroll
    this.$store.dispatch('prices/LOAD')

  },
};
</script>

<style>

</style>
